import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { pageTitle } from '../../helper'
import Accordion from '../Accordion'
import Button from '../Button'
import Cta from '../Cta'
import IconBox from '../IconBox'
import PageHeading from '../PageHeading'
import Div from '../Div'
import SectionHeading from '../SectionHeading'
import TestimonialSlider from '../Slider/TestimonialSlider'
import Spacing from '../Spacing'

export default function TechnologyPage() {
    pageTitle('Technology Services');
    const params = useParams();
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <PageHeading
                title='Technology Services'
                bgSrc='/images/service_hero_bg.jpeg'
                pageLinkText={params.serviceDetailsId || 'Technology'}
            />
            <Spacing lg='145' md='80'/>
            <Div className="container">
                <SectionHeading
                    title='Technology Working Process'
                    subtitle='Technology Solutions'
                    variant='cs-style1 text-center'
                />
                <Spacing lg='90' md='45'/>
                <Div className="row">
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_1.svg'
                            title='Discovery & Assessment'
                            subtitle='We begin with a thorough evaluation of your current technology landscape, identifying strengths, weaknesses, and opportunities for improvement. Through stakeholder interviews and system analysis, we gain a deep understanding of your requirements.'
                        />
                        <Spacing lg='30' md='30'/>
                    </Div>
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_2.svg'
                            title='Solution Design'
                            subtitle='Based on our assessment findings, we architect comprehensive technology solutions that address your immediate needs while supporting long-term objectives. Our experts consider scalability, security, integration capabilities, and total cost of ownership.'
                        />
                        <Spacing lg='30' md='30'/>
                    </Div>
                    <Div className="col-lg-4">
                        <IconBox
                            icon='/images/icons/service_icon_3.svg'
                            title='Implementation & Support'
                            subtitle='Our technical teams execute the solution with precision, following established best practices and quality assurance protocols. We provide comprehensive documentation, training, and ongoing support to ensure smooth adoption and continued success.'
                        />
                        <Spacing lg='30' md='30'/>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='120' md='50'/>
            <Div className="container">
                <Div className="row">
                    <Div className="col-lg-6">
                        <h2 className="cs-font_30 cs-m0">Unlock the power of technology</h2>
                        <Spacing lg='30' md='30'/>
                        <p>At ACE Cloud Solution, we leverage cutting-edge technologies to solve complex business challenges and drive digital transformation. Our expert team delivers innovative solutions tailored to your specific needs and objectives.</p>
                        <p>We implement powerful technology solutions that enhance operational efficiency, improve data utilization, and create competitive advantages. With a focus on security, scalability, and integration, our technology services provide the foundation for sustainable business growth.</p>
                        <Spacing lg='30' md='30'/>
                        <h3 className="cs-font_22 cs-m0">Key benefits of our technology solutions:</h3>
                        <Spacing lg='15' md='15'/>
                        <ul className="cs-list cs-style1">
                            <li>Increased operational efficiency and productivity</li>
                            <li>Enhanced data security and compliance</li>
                            <li>Scalable infrastructure that grows with your needs</li>
                            <li>Seamless integration across systems and platforms</li>
                            <li>Reduced IT costs through optimization</li>
                        </ul>
                    </Div>
                    <Div className="col-lg-5 offset-lg-1">
                        <Div className="cs-image_layer cs-style1">
                            <Div className="cs-image_layer_in">
                                <img src="/images/service_4.jpeg" alt="Technology Solutions" className="w-100" />
                            </Div>
                        </Div>
                        <Spacing lg='0' md='40'/>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='100' md='80'/>
            <Div className="container">
                <Div className="row align-items-center">
                    <Div className="col-xl-5 col-lg-6">
                        <Div className="cs-radius_15 cs-shine_hover_1">
                            <img src="/images/service_img_1.jpeg" alt="Service" className='cs-radius_15 w-100' />
                        </Div>
                        <Spacing lg='0' md='40'/>
                    </Div>
                    <Div className="col-lg-6 offset-xl-1">
                        <h2 className="cs-font_50 cs-m0">Below our most technology related services</h2>
                        <Spacing lg='50' md='30'/>
                        <Div className="row">
                            <Div className="col-lg-6">
                                <Button btnLink='' btnText='Cloud infrastructure' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='DevOps implementation' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Custom software' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='System integration' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Data analytics & BI' variant='cs-type2'/>
                                <Spacing lg='0' md='10'/>
                            </Div>
                            <Div className="col-lg-6">
                                <Button btnLink='' btnText='Cybersecurity services' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Automation solutions' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Enterprise architecture' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='Technology consulting' variant='cs-type2'/>
                                <Spacing lg='20' md='10'/>
                                <Button btnLink='' btnText='IT support & maintenance' variant='cs-type2'/>
                                <Spacing lg='0' md='10'/>
                            </Div>
                        </Div>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='150' md='80'/>
            {/*<TestimonialSlider />*/}
            <Spacing lg='145' md='80'/>
            <Div className="container cs-shape_wrap_4">
                <Div className="cs-shape_4"></Div>
                <Div className="cs-shape_4"></Div>
                <Div className="container">
                    <Div className="row">
                        <Div className="col-xl-5 col-lg-6">
                            <SectionHeading
                                title='Some pre questions and answers'
                                subtitle="FAQ's"
              />
              <Spacing lg='90' md='45'/>
                        </Div>
                        <Div className="col-lg-6 offset-xl-1">
                            <Accordion/>
                        </Div>
                    </Div>
                </Div>
            </Div>
            <Spacing lg='150' md='80'/>
            <Div className="container">
                <Cta
                    title="Let's transform your <br />business with <i>technology</i>"
                    btnText='Schedule a Consultation'
                    btnLink='/contact'
                    bgSrc='/images/cta_bg.jpeg'
                    />
            </Div>
        </>
    )
}